import {
  Dashboard,
  PhotoLibrary,
  Devices,
  Token,
  PlaylistPlay,
  Schedule,
  Assessment,
  People,
  Settings,
  AdminPanelSettings,
} from '@mui/icons-material';

import type { NavigationItem } from '../types';
import { UserRole } from '../types';

// Конфигурация навигационного меню
export const navigationConfig: NavigationItem[] = [
  {
    label: 'navigation.dashboard',
    path: '/dashboard',
    icon: Dashboard,
    roles: [
      UserRole.ADMIN,
      UserRole.MANAGER,
      UserRole.SCHEDULER,
      UserRole.ENGINEER,
      UserRole.DIRECTOR,
      UserRole.VIEWER,
    ],
  },
  {
    label: 'navigation.media',
    path: '/media',
    icon: PhotoLibrary,
    roles: [
      UserRole.ADMIN,
      UserRole.MANAGER,
      UserRole.SCHEDULER,
      UserRole.VIEWER,
    ],
  },
  {
    label: 'devices.management.title',
    path: '/devices',
    icon: Devices,
    roles: [
      UserRole.ADMIN,
      UserRole.MANAGER,
      UserRole.ENGINEER,
    ],
  },
  {
    label: 'navigation.playlists',
    path: '/playlists',
    icon: PlaylistPlay,
    roles: [
      UserRole.ADMIN,
      UserRole.MANAGER,
      UserRole.SCHEDULER,
    ],
  },
  {
    label: 'navigation.schedule',
    path: '/schedule',
    icon: Schedule,
    roles: [
      UserRole.ADMIN,
      UserRole.MANAGER,
      UserRole.SCHEDULER,
    ],
  },
  {
    label: 'navigation.reports',
    path: '/reports',
    icon: Assessment,
    roles: [
      UserRole.ADMIN,
      UserRole.MANAGER,
      UserRole.DIRECTOR,
    ],
  },
  {
    label: 'navigation.users',
    path: '/users',
    icon: People,
    roles: [UserRole.ADMIN],
  },
  {
    label: 'navigation.settings',
    path: '/settings',
    icon: Settings,
    roles: [
      UserRole.ADMIN,
      UserRole.MANAGER,
    ],
  },
];

// Получить элементы навигации для текущей роли пользователя
export const getNavigationForRole = (userRole: UserRole): NavigationItem[] => {
  return navigationConfig.filter(item => 
    !item.roles || item.roles.includes(userRole)
  );
};

// Проверить доступ к маршруту
export const hasAccessToRoute = (path: string, userRole: UserRole): boolean => {
  const item = navigationConfig.find(navItem => navItem.path === path);
  if (!item) return true; // Если маршрут не в конфигурации, разрешаем доступ
  return !item.roles || item.roles.includes(userRole);
};

// Получить breadcrumbs для текущего пути
export const getBreadcrumbs = (pathname: string): Array<{ label: string; path?: string }> => {
  const pathSegments = pathname.split('/').filter(Boolean);
  const breadcrumbs: Array<{ label: string; path?: string }> = [];

  // Добавляем "Главная" если не на главной странице
  if (pathname !== '/dashboard') {
    breadcrumbs.push({
      label: 'navigation.dashboard',
      path: '/dashboard',
    });
  }

  // Ищем соответствующий элемент навигации
  const currentItem = navigationConfig.find(item => item.path === pathname);
  if (currentItem && pathname !== '/dashboard') {
    breadcrumbs.push({
      label: currentItem.label,
    });
  }

  return breadcrumbs;
};

// Получить заголовок страницы
export const getPageTitle = (pathname: string): string => {
  const item = navigationConfig.find(navItem => navItem.path === pathname);
  return item?.label || 'app.title';
}; 
 
 
 